export const JWT_TOKEN_KEY = 'JWT_TOKEN'
export const AUTH_SUCCESS_EVENT = 'onAuthSuccess'
